<template>
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.25" fill-rule="evenodd" clip-rule="evenodd" d="M0 17C0 14.2386 2.23858 12 5 12H11C13.7614 12 16 14.2386 16 17C16 18.6569 14.6569 20 13 20H3C1.34315 20 0 18.6569 0 17Z" fill="#9299A5"/>
    <path d="M8 0C5.23858 0 3 2.23858 3 5C3 7.76142 5.23858 10 8 10C10.7614 10 13 7.76142 13 5C13 2.23858 10.7614 0 8 0Z" fill="#9299A5"/>
  </svg>
</template>

